export default "__VITE_ASSET__RiIJo$no__"